export default {
  days: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],

  common: {
    save:          'บันทึก',
    close:         'ปิด',
    cancel:        'ยกเลิก',
    back:          'กลับ',
    add:           'เพิ่ม',
    noData:        'ไม่มีข้อมูล',
    male:          'ชาย',
    female:        'หญิง',
    error:         'เกิดข้อผิดพลาด',
    studyYear:     (y) => `ปีการศึกษา ${y}`,
    studyYearShort:(y) => `ปี ${y}`,
    classNo:       (c, r) => `ชั้น ${c} ห้อง ${r}`,
    studentCount:  (n) => `นักเรียน ${n} คน`,
    personCount:   (n) => `${n} คน`,
    active:        'ปกติ',
    withdrawn:     'ออก',
    years:         'ปี',
  },

  subjectList: {
    pageTitle:        'รายวิชาของฉัน (ภาคศาสนา)',
    noTeaching:       'ไม่มีข้อมูลการสอน',
    colCode:          'รหัสวิชา',
    colName:          'ชื่อวิชา',
    colSchedule:      'ตารางคาบ',
    colAttend:        'เช็คชื่อ',
    colScore:         'คะแนน',
    studentListBtn:   'รายชื่อนักเรียน',
    attendBtn:        'เช็คชื่อ',
    scoreBtn:         'คะแนน',
    noStudents:       'ไม่มีรายชื่อนักเรียน',
    studentInfo:      'ข้อมูลนักเรียน',
    identity:         'ข้อมูลส่วนตัว',
    address:          'ที่อยู่',
    father:           'บิดา',
    mother:           'มารดา',
    guardian:         'ผู้ปกครอง',
    dormitory:        'หอพัก',
    studentId:        'รหัสนักเรียน',
    idCard:           'บัตรประชาชน',
    gender:           'เพศ',
    status:           'สถานะ',
    birthDate:        'วันเกิด',
    age:              'อายุ',
    fatherName:       'ชื่อบิดา',
    fatherPhone:      'เบอร์โทรบิดา',
    motherName:       'ชื่อมารดา',
    motherPhone:      'เบอร์โทรมารดา',
    guardianName:     'ชื่อผู้ปกครอง',
    guardianRelation: 'ความสัมพันธ์',
    guardianPhone:    'เบอร์โทรผู้ปกครอง',
    dormName:         'หอพัก',
    village:          'หมู่บ้าน',
    checkinDate:      'วันที่เข้าพัก',
    noDorm:           'ไม่ได้พักในหอพัก',
  },

  attendance: {
    pageTitle:    'เช็คชื่อนักเรียน',
    noSchedule:   'ไม่มีตารางสอนสำหรับวันนี้',
    colPeriod:    'คาบ',
    colTime:      'เวลา',
    colSubject:   'วิชา',
    colClass:     'ห้อง',
    colGender:    'เพศ',
    checkBtn:     'เช็คชื่อ',
  },

  checkAttendance: {
    pageTitle:          'เช็คชื่อ — ห้อง',
    breadcrumb:         'เช็คชื่อ',
    alreadyChecked:     'เช็คชื่อคาบนี้แล้ว',
    editLink:           'คลิกเพื่อแก้ไข',
    labelDate:          'วันที่:',
    labelTopic:         'หัวข้อ:',
    topicPlaceholder:   'ระบุหัวข้อการเรียนวันนี้',
    saveBtn:            'บันทึกการเช็คชื่อ',
    saveSuccess:        'บันทึกสำเร็จ',
    noStudents:         'ไม่มีรายชื่อนักเรียน',
    colId:              'รหัส',
    colName:            'ชื่อ-สกุล',
    colStatus:          'สถานะ',
    statusPresent:      'มาเรียน',
    statusLate:         'สาย',
    statusLeave:        'ลา',
    statusAbsent:       'ขาด',
    statusWithdrawn:    'ออก',
    errorTitle:         'ข้อผิดพลาด',
    viewCard:           'การ์ด',
    viewTable:          'ตาราง',
  },

  editAttendance: {
    pageTitle:        'แก้ไขการเช็คชื่อ — ห้อง',
    breadcrumb:       'เช็คชื่อ',
    breadcrumbEdit:   (r) => `แก้ไข — ห้อง ${r}`,
    labelDate:        'วันที่:',
    labelTopic:       'หัวข้อ:',
    topicPlaceholder: 'ระบุหัวข้อการเรียน',
    saveSuccess:      'แก้ไขสำเร็จ',
    noData:           'ไม่มีข้อมูล',
    colId:            'รหัส',
    colName:          'ชื่อ-สกุล',
    colStatus:        'สถานะ',
    saveBtn:          'บันทึก',
    backBtn:          'กลับ',
    errorTitle:       'ข้อผิดพลาด',
  },

  scoreEntry: {
    pageTitle:    'บันทึกคะแนน (ภาคศาสนา)',
    unsaved:      'มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก',
    studentCount: (n) => `รายชื่อนักเรียน (${n} คน)`,
    average:      'ค่าเฉลี่ย',
    semester1:    'ภาคเรียนที่ 1',
    semester2:    'ภาคเรียนที่ 2',
    total:        'รวม',
    saveBtn:      'บันทึกคะแนน',
    saveSuccess:  'บันทึกสำเร็จ',
    saveError:    'เกิดข้อผิดพลาด',
    noStudents:   'ไม่มีรายชื่อนักเรียน',
    colId:        'รหัส',
    colArabicName:'ชื่อภาษาอาหรับ',
    colName:      'ชื่อ-สกุล',
  },

  manageTeaching: {
    pageTitle:               'ตารางการสอน (จัดการ)',
    classRoom:               'ห้องเรียน',
    filterClass:             'ชั้น',
    filterGender:            'เพศ',
    noRooms:                 'ไม่มีห้องเรียน',
    selectRoom:              'เลือกห้องเรียนเพื่อดูตารางสอน',
    addTeachingBtn:          'เพิ่มรายวิชา',
    noTeachings:             'ยังไม่มีการมอบหมายการสอนในห้องนี้',
    colCode:                 'รหัส',
    colSubjectName:          'ชื่อวิชา',
    colTeacher:              'ครูผู้สอน',
    colDayPeriod:            'วัน/คาบ',
    assignPeriodTitle:       'กำหนดคาบ',
    addTeachingModalTitle:   'เพิ่มรายวิชา',
    labelSubject:            'วิชา',
    subjectPlaceholder:      '-- เลือกวิชา --',
    allSubjectsAssigned:     'มีครูสอนทุกวิชาแล้ว',
    labelTeacher:            'ครูผู้สอน',
    teacherPlaceholder:      '-- เลือกครู --',
    labelDay:                'วัน',
    dayPlaceholder:          '-- เลือกวัน --',
    labelPeriod:             'คาบ',
    periodPlaceholder:       '-- เลือกคาบ --',
    noPeriods:               'ยังไม่มีคาบที่กำหนด',
    duplicatePeriod:         'คาบนี้ถูกเพิ่มแล้ว',
    confirmDeleteTitle:      'ยืนยันการลบ?',
    confirmDeleteBtn:        'ลบ',
    cancelDeleteBtn:         'ยกเลิก',
    deleteFailMsg:           'ไม่สามารถลบได้',
    errorShort:              'ข้อผิดพลาด',
  },

  teachingTracking: {
    pageTitle:          'ติดตามการสอน',
    classRoom:          'ห้องเรียน',
    noRooms:            'ไม่มีห้องเรียน',
    selectRoom:         'เลือกห้องเรียนเพื่อดูสถานะการสอน',
    noTeachings:        'ยังไม่มีการมอบหมายการสอนในห้องนี้',
    colCode:            'รหัส',
    colSubjectName:     'ชื่อวิชา',
    colTeacher:         'ครูผู้สอน',
    colAttSessions:     'ครั้งที่เช็คชื่อ',
    colStudentsScore:   'นักเรียนมีคะแนน',
    times:              'ครั้ง',
    attendBtn:          'เช็คชื่อ',
    scoreBtn:           'คะแนน',
    viewLogBtn:         'บันทึกการสอน',
  },

  listTeachTracking: {
    pageTitle:    'บันทึกการสอน',
    breadHome:    'หน้าหลัก',
    breadCurrent: 'บันทึกการสอน',
    listTitle:    'รายการบันทึก',
    countTimes:   (n) => `${n} ครั้ง`,
    noRecords:    'ยังไม่มีบันทึกการสอน',
    colDate:      'วันที่',
    colTime:      'เวลา',
    colPeriod:    'คาบ',
    colTopic:     'หัวข้อที่สอน',
    colPresent:   'มา',
    colAbsent:    'ขาด',
    colLate:      'สาย',
    colLeave:     'ลา',
    colTotal:     'รวม',
    noTopic:      'ไม่ระบุหัวข้อ',
  },

  classGrade: {
    pageTitle:     'ตารางคะแนน (ภาคศาสนา)',
    classRoom:     'ห้องเรียน',
    noRooms:       'ไม่มีห้องเรียน',
    selectRoom:    'เลือกห้องเรียนเพื่อดูคะแนน',
    tabScores:     'คะแนน',
    tabAttendance: 'การเข้าเรียน',
    noSubjects:    'ยังไม่มีวิชาในห้องนี้',
    noAttendance:  'ยังไม่มีข้อมูลการเข้าเรียน',
    colNo:         'รหัส',
    colName:       'ชื่อ-สกุล',
    colAverage:    'ค่าเฉลี่ย',
    colPresent:    'มาเรียน',
    colAbsent:     'ขาด',
    colLate:       'สาย',
    colLeave:      'ลา',
    colTotal:      'รวม',
    genderLabel:   (g) => g === 'male' ? 'ชาย' : g === 'female' ? 'หญิง' : 'รวม',
  },

  advisorHome: {
    pageTitle:         'ห้องเรียนของฉัน (ภาคศาสนา)',
    noRoom:            'ไม่มีห้องเรียนในปีการศึกษานี้',
    labelStudents:     'นักเรียน',
    labelSubjects:     'รายวิชา',
    cardStudentsTitle: 'รายชื่อนักเรียน',
    cardStudentsDesc:  'ดูนักเรียนทั้งหมดในห้องเรียน',
    cardStudentsBtn:   'ดูนักเรียน',
    cardGradesTitle:   'คะแนน & การเข้าเรียน',
    cardGradesDesc:    'ดูคะแนนและการเข้าเรียนของนักเรียน',
    cardGradesBtn:     'ดูคะแนน',
  },

  advisorGrade: {
    pageTitle:     'คะแนน & การเข้าเรียน',
    noRoom:        'ไม่มีห้องเรียนในปีการศึกษานี้',
    tabScores:     'คะแนน',
    tabAttendance: 'การเข้าเรียน',
    noSubjects:    'ยังไม่มีวิชาในห้องนี้',
    noAttendance:  'ยังไม่มีข้อมูลการเข้าเรียน',
    colNo:         'รหัส',
    colName:       'ชื่อ-สกุล',
    colAverage:    'ค่าเฉลี่ย',
    colPresent:    'มาเรียน',
    colAbsent:     'ขาด',
    colLate:       'สาย',
    colLeave:      'ลา',
    colTotal:      'รวม',
  },

  advisorStudents: {
    pageTitle:     'รายชื่อนักเรียน',
    noRoom:        'ไม่มีห้องเรียนในปีการศึกษานี้',
    totalStudents: 'จำนวนนักเรียน',
    noStudents:    'ยังไม่มีนักเรียนในห้องนี้',
    colNo:         'รหัส',
    colName:       'ชื่อ-สกุล',
    colArabicName: 'ชื่อภาษาอาหรับ',
    colGender:     'เพศ',
  },

  manageRoom: {
    pageTitle:        'จัดการห้องเรียน (ภาคศาสนา)',
    breadHome:        'หน้าหลัก',
    breadCurrent:     'ห้องเรียนภาคศาสนา',
    addBtn:           'เพิ่มห้อง',
    filterAllGender:  '-- ทุกเพศ --',
    filterAllClass:   '-- ทุกชั้น --',
    listTitle:        'รายการห้องเรียน',
    noRooms:          'ไม่มีข้อมูลห้องเรียน',
    colClass:         'ชั้น',
    colRoom:          'ห้อง',
    colGender:        'เพศ',
    colProgram:       'โปรแกรม',
    colAdvisor:       'ครูที่ปรึกษา',
    colStudents:      'นักเรียน',
    modalAddTitle:    'เพิ่มห้องเรียน',
    modalEditTitle:   'แก้ไขห้องเรียน',
    labelClass:       'ชั้น',
    classPlaceholder: '-- เลือกชั้น --',
    labelRoom:        'ห้อง (เลขห้อง)',
    roomPlaceholder:  'เช่น 1, 2, A',
    labelGender:      'เพศนักเรียน',
    labelProgram:     'โปรแกรม',
    labelAdvisor:     'ครูที่ปรึกษา',
    noneOption:       '-- ไม่มี --',
    incompleteTitle:  'ข้อมูลไม่ครบ',
    incompleteMsg:    'กรุณากรอกเลขห้อง เพศ และชั้น',
    successTitle:     'สำเร็จ',
    errorTitle:       'ข้อผิดพลาด',
    successUpdate:    'แก้ไขห้องเรียนแล้ว',
    successAdd:       'เพิ่มห้องเรียนแล้ว',
    successDelete:    'ลบห้องเรียนแล้ว',
    confirmDelete:    (r) => `ลบห้อง ${r}?`,
    confirmBtn:       'ลบ',
    cancelBtn:        'ยกเลิก',
    genderLabel:      { m: 'ชาย', f: 'หญิง' },
  },

  manageCurriculum: {
    pageTitle:           'จัดการหลักสูตร (ภาคศาสนา)',
    breadHome:           'หน้าหลัก',
    breadCurrent:        'หลักสูตรภาคศาสนา',
    syllabusTitle:       'หลักสูตรทั้งหมด',
    assignedTitle:       'การมอบหมายหลักสูตร',
    addBtn:              'เพิ่ม',
    assignBtn:           'มอบหมาย',
    colSylYear:          'ปีหลักสูตร',
    noData:              'ไม่มีข้อมูล',
    colSyllabus:         'หลักสูตร',
    colClass:            'ชั้น',
    colProgram:          'โปรแกรม',
    colSubjects:         (n) => `${n} รายวิชา`,
    modalAddSylTitle:    'เพิ่มหลักสูตร',
    labelSylYear:        'ปีหลักสูตร (เช่น 2567)',
    modalAssignTitle:    'มอบหมายหลักสูตร',
    labelSyllabus:       'หลักสูตร',
    sylPlaceholder:      '-- เลือกหลักสูตร --',
    labelClass:          'ชั้น',
    classPlaceholder:    '-- เลือกชั้น --',
    labelProgram:        'โปรแกรม',
    noneOption:          '-- ไม่มี --',
    successTitle:        'สำเร็จ',
    errorTitle:          'ข้อผิดพลาด',
    incompleteTitle:     'ข้อมูลไม่ครบ',
    confirmBtn:          'ลบ',
    cancelBtn:           'ยกเลิก',
    addedSyl:            'เพิ่มหลักสูตรแล้ว',
    deletedSyl:          'ลบหลักสูตรแล้ว',
    confirmDeleteSyl:    (y) => `ลบหลักสูตรปี ${y}?`,
    assignedSuccess:     'มอบหมายหลักสูตรแล้ว',
    cancelledAssign:     'ยกเลิกการมอบหมายแล้ว',
    confirmCancelAssign: 'ยกเลิกการมอบหมายหลักสูตร?',
    incompleteAssignMsg: 'กรุณาเลือกหลักสูตรและชั้น',
  },

  manageSubject: {
    pageTitle:        'จัดการรายวิชา (ภาคศาสนา)',
    breadHome:        'หน้าหลัก',
    breadSyllabus:    'หลักสูตร',
    breadCurrent:     'รายวิชา',
    addBtn:           'เพิ่มรายวิชา',
    listTitle:        (n) => `รายวิชา (${n})`,
    noSubjects:       'ยังไม่มีรายวิชา',
    colCode:          'รหัสวิชา',
    colName:          'ชื่อวิชา',
    modalAddTitle:    'เพิ่มรายวิชา',
    modalEditTitle:   'แก้ไขรายวิชา',
    labelCode:        'รหัสวิชา',
    codePlaceholder:  'เช่น IS101',
    labelName:        'ชื่อวิชา',
    namePlaceholder:  'ชื่อวิชา',
    incompleteTitle:  'ข้อมูลไม่ครบ',
    incompleteMsg:    'กรุณากรอกรหัสและชื่อวิชา',
    successTitle:     'สำเร็จ',
    errorTitle:       'ข้อผิดพลาด',
    successUpdate:    'แก้ไขรายวิชาแล้ว',
    successAdd:       'เพิ่มรายวิชาแล้ว',
    successDelete:    'ลบรายวิชาแล้ว',
    confirmDelete:    (c) => `ลบรายวิชา ${c}?`,
    confirmBtn:       'ลบ',
    cancelBtn:        'ยกเลิก',
  },

  manageStudents: {
    pageTitle:          (r) => `นักเรียนในห้อง ${r}`,
    breadHome:          'หน้าหลัก',
    breadRooms:         'ห้องเรียน',
    breadCurrent:       'นักเรียน',
    filterAllClass:     '-- ชั้น --',
    filterAllGender:    '-- เพศ --',
    filterAllRoom:      '-- ห้อง --',
    selectRoom:         'กรุณาเลือกห้องเรียนจากรายการด้านบน',
    addStudentTitle:    'เพิ่มนักเรียน',
    labelStudentId:     'รหัสนักเรียน',
    searchPlaceholder:  'กรอกรหัสนักเรียน',
    notFound:           (id) => `ไม่พบนักเรียนรหัส ${id}`,
    enrollBtn:          'ลงทะเบียนเข้าห้องนี้',
    searchHint:         'ค้นหาด้วยรหัสนักเรียน แล้วกดลงทะเบียน',
    listTitle:          (n) => `รายชื่อนักเรียน (${n} คน)`,
    noStudents:         'ยังไม่มีนักเรียนในห้องนี้',
    colNo:              'รหัส',
    colName:            'ชื่อ-สกุล',
    colArabicName:      'ชื่อภาษาอาหรับ',
    colGender:          'เพศ',
    colStatus:          'สถานะ',
    statusBadge:        { 0: 'ออก', 1: 'กำลังเรียน', 3: 'นักเรียนใหม่' },
    noInfo:             'ไม่มีข้อมูล',
    genderLabel:        (g) => g === 'm' ? 'ชาย' : 'หญิง',
    labelGender:        'เพศ',
    labelStatus:        'สถานะ',
    confirmUnenroll:    (name) => `นำ ${name} ออกจากห้อง?`,
    successTitle:       'สำเร็จ',
    errorTitle:         'ข้อผิดพลาด',
    enrolledSuccess:    'ลงทะเบียนนักเรียนแล้ว',
    unenrolledSuccess:  'นำนักเรียนออกแล้ว',
    confirmUnenrollBtn: 'นำออก',
    cancelBtn:          'ยกเลิก',
  },
}
